<template>
    <form class="saas-account-form linear-todo-form" @submit.prevent="proceed" @keydown="todoForm.errors.clear($event.target.name)">
        <div class="form-group">
            <label class="mb-1" for="">{{trans('todo.title')}}</label>
            <input class="form-control" type="text" value="" v-model="todoForm.title" name="title" :placeholder="trans('todo.title')">
            <show-error :form-name="todoForm" prop-name="title"></show-error>
        </div>
        <div class="form-group">
            <label class="mb-1" for="">{{trans('todo.date')}}</label>
            <datepicker v-model="todoForm.date" :bootstrapStyling="true" @selected="todoForm.errors.clear('date')" :placeholder="trans('todo.date')"></datepicker>
            <show-error :form-name="todoForm" prop-name="date"></show-error>
        </div>
        <div class="form-group">
            <label class="mb-1" for="">{{trans('todo.description')}}</label>
            <autosize-textarea v-model="todoForm.description" rows="2" name="description" :placeholder="trans('todo.description')"></autosize-textarea>
            <show-error :form-name="todoForm" prop-name="description"></show-error>
        </div>
        <div class="d-flex flex-wrap gap-2 justify-content-end">
            <router-link to="/todo" class="btn btn-sm admin-form-btn-cancel" v-show="id">{{trans('general.cancel')}}</router-link>
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <span v-if="id">{{trans('general.update')}}</span>
                <span v-else>{{trans('general.save')}}</span>
            </button>
        </div>
    </form>
</template>


<script>
    import datepicker from 'vuejs-datepicker'
    import autosizeTextarea from '../../components/autosize-textarea'

    export default {
        components: {datepicker,autosizeTextarea},
        data() {
            return {
                todoForm: new Form({
                    title : '',
                    description : '',
                    date: ''
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getTodo();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateTodo();
                else
                    this.storeTodo();
            },
            storeTodo(){
                this.todoForm.date = moment(this.todoForm.date).format('YYYY-MM-DD');
                this.todoForm.post('/api/todo')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed')
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getTodo(){
                axios.get('/api/todo/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.todoForm.title = response.title;
                        this.todoForm.description = response.description;
                        this.todoForm.date = response.date;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/todo');
                    });
            },
            updateTodo(){
                this.todoForm.date = moment(this.todoForm.date).format('YYYY-MM-DD');
                this.todoForm.patch('/api/todo/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/todo');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.linear-todo-form .form-group {
    margin-bottom: 0.95rem;
}

.linear-todo-form label {
    color: #475569;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.linear-todo-form .form-control {
    border-color: #e2e8f0;
    border-radius: 10px;
    color: #0f172a;
    font-weight: 600;
}
</style>
